import Center from "../../../../components/center";
import Editorial from "../../../../components/editorial";
import Head from "../../../../components/head";
import Hero from "../../../../components/hero";
import CandidateBio from "../../../../components/candidate-bio";
import namedRoutes from "../../../../settings/routes";

const candidate = {
  name: "Jim Cline",
  since: 2008,
  email: "undihrs@gmail.com",
  photo: "/images/candidates/jim-cline.jpg",
};

const pageTitle = `2025 - Jim Cline's Letter to the HOA - Klahanie.info`;

const JimCline = () => (
  <Editorial>
    <Head title={pageTitle} />
    <Hero background="/images/backgrounds/forest-path.jpg">
      <h1>
        <span style="font-size: 0.5em; font-weight: 400; display: block; margin-bottom: 0.25em; text-transform: none;">
          Jim Cline's{" "}
        </span>
        Letter
      </h1>
      <h2 style="font-size: 1.1em; font-weight: 400;">
        <span>Sent to the Klahanie HOA</span>
      </h2>
    </Hero>
    <div>
      <Center>
        <CandidateBio
          img={candidate.photo}
          name={candidate.name}
          since={candidate.since}
          email={candidate.email}
          links={[
            { text: "View Jim's Bio", href: namedRoutes.archive2025.jimCline },
          ]}
        >
          <div>
            <p style="font-size: 0.8em; margin-bottom: 0.2em; opacity: 0.7; font-style: italic;">
              Sent on January 14, 2025
            </p>
            <p>
              I am writing on behalf of an organized group of HOA members who
              are concerned about the Board’s decision to spend funds on a
              community center. This funding has never been approved by the
              owners. As you know, this action has been widely discussed in
              recent HOA Board meetings and in community social media. The vote
              by the Board to move forward with spending money on engineering
              designs for a project that has not been approved or properly
              funded is deeply troubling to many.
            </p>
            <p>
              After carefully reviewing documents and information supplied by
              the HOA and posted in the “FAQ” section, we have determined a
              significant lack of shared information exists that a reasonable
              person would need in order to know whether the proposed plans are
              merited or not. Significant questions also exist about the legal
              authority of the Board to expend money for developing engineering
              designs for a project not funded in the authorized budget.
              Therefore, we must insist as Klahanie owners that you allocate
              staff and board time to prioritize responding to the following
              information request. Unless and until this information and
              provided and explanations developed and communicated by the Board,
              no design contract should be executed. These requests are for all
              documents that are, or should be, in the possession of the
              Klahanie Homeowners Association, including the HOA staff and Board
              members:
            </p>
            <ol>
              <li>
                All reports concerning the condition and potential repairs for
                the Mountainside Pool;
              </li>
              <li>
                All documents relating to and communications between the HOA
                staff regarding the repair of the Mountainside pool;
              </li>
              <li>
                All cost estimates concerning the repair of the Mountainside
                pool;
              </li>
              <li>
                All Communications between the HOA and third parties concerning
                repairs for the Mountainside pool;
              </li>
              <li>
                All records for the past five years relating to the FAQ
                statement that “[t]he teams that rent our pools provide more
                value than they receive, as the association earns more from them
                than the costs incurred,” including but not limited to any and
                all assessment of costs of pool operation, annual rental income,
                usage fees, and hours of usage;
              </li>
              <li>
                All communications between King County and the HOA regarding
                repair or replacement of the current HOA office;
              </li>
              <li>
                All communications between the City of Sammamish and the HOA
                regarding repair or replacement of the current HOA office;
              </li>
              <li>
                All documents relating to zoning and/or wetland issues
                concerning the existing office location;
              </li>
              <li>
                All documents relating to the repair or replacement of the
                current office building, including but not limited to
                feasibility and cost or repair;
              </li>
              <li>
                All documents relating to the Board’s adopted reserve fund
                estimate of the cost of office replacement;
              </li>
              <li>
                All communications between the HOA and the author of the reserve
                study concerning the cost of replacing the office building;
              </li>
              <li>
                All communications between the HOA and third parties concerning
                the cost of replacing the office building;
              </li>
              <li>
                All communications between the HOA and the Klahanie Center
                landlord or agent concerning rental of space;
              </li>
              <li>
                Any documents regarding the office space/square footage needs
                for the HOA offices;
              </li>
              <li>
                All written Communications between HOA and Urbal Architecture
              </li>
              <li>
                All written communications between the HOA and Lineage Real
                Estate;
              </li>
              <li>
                All documents regarding the cost and design of the proposed
                community center;
              </li>
              <li>
                All documents in possession of the Building and Special Projects
                Committee, F&O Committee, and Sports and Recreation Committee
                concerning the replacement or repair of the Mountainside pool,
                and office;
              </li>
              <li>
                All documents regarding the impact of the proposed project on
                insurance rates;
              </li>
              <li>
                All documents regarding the impact of the proposed projects on
                operating and maintenance costs;
              </li>
              <li>
                Any communications, documents or reports between the HOA
                accountant and the HOA regarding the classification of proposed
                expenditures for the community center project.
              </li>
            </ol>
            <p>
              We are extremely concerned that the Board has authorized
              expenditures that are inconsistent with the adopted and member
              approved budget. That reserve study expressly incorporated into
              the budget calls for replacement of the current office at the cost
              of $779,710. The reserve study says <em>nothing</em> about any
              $12.5 million community center. The Board is{" "}
              <em>improperly diverting</em> nearly 40% of that budgeted and
              approved amount into developing plans for an entirely different
              project <em>not in the owner approved budget</em>.
            </p>
            <p>
              It also appears that the currently published bylaws allowing Board
              authority to incur debt on behalf of the HOA may not be valid.
              There is a lack of documentation demonstrating that the previous
              bylaws requiring owner debt approval were legally removed. A
              discussion about Board authority relative to owner authority needs
              to be undertaken immediately so that the Board does not proceed
              further in an unauthorized manner by incurring unapproved loans.
            </p>
            <p>
              This diversion stands as an important issue on its own, but the
              lack of information supplied by the HOA to its members also needs
              to be addressed ASAP. We request that you prioritize this
              information in recognition of the status it deserves and supply
              all requested records by Tuesday January 28. If these documents
              exist, they would have been an essential element of the Board’s
              decision-making and should be easily retrievable.
            </p>
            <p>
              We are asking at its next Board meeting for the Board to schedule
              another special meeting to allow member input following the
              January 28 disclosure of these records. The agenda should also
              include a discussion about suspending the current diversion of
              funds to the unapproved community center project.
            </p>
          </div>
        </CandidateBio>
      </Center>
    </div>
  </Editorial>
);

export default JimCline;
